import { GetPageByRouteQuery } from "apollo"
import DesignA from "./DesignA"
import DesignB from "./DesignB"
import DesignC from "./DesignC"
import DesignD from "./DesignD"

export default function LandingPage({
  data,
  locale,
  tooltipText = "",
}: {
  data: GetPageByRouteQuery
  locale: string
  tooltipText?: string
}) {
  const contentType = data.page?.contentType?.alias
  const designA = contentType === "landingPageTemplate1"
  const designB = contentType === "landingPageTemplate2"
  const designC = contentType === "landingPageTemplate3"
  const designD = contentType === "landingPageTemplate4"
  if (designA) {
    return (
      <DesignA data={data.page} locale={locale} tooltipText={tooltipText} />
    )
  }
  if (designB) {
    return (
      <DesignB data={data.page} locale={locale} tooltipText={tooltipText} />
    )
  }
  if (designC) {
    return (
      <DesignC data={data.page} locale={locale} tooltipText={tooltipText} />
    )
  }
  if (designD) {
    return (
      <DesignD data={data.page} locale={locale} tooltipText={tooltipText} />
    )
  }
  return null
}
